import Components from "./components";
import Services from "./services";

const rootDir = "app/notifications";

export default angular.module("tfApp.notifications", [Components(rootDir), Services(rootDir)])
                      .name;
